module.exports = __webpack_public_path__ + "static/media/5-1.80d0956.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/5-1.mp4
// module id = l14w
// module chunks = 0